module.exports = __webpack_public_path__ + "static/Faktum-SemiBold.95cbfc5d.otf";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/_fonts/Faktum-SemiBold.otf
// module id = 433
// module chunks = 114276838955818